// 	export default  [
// 	{ icon:'business', title: "办公业务",value: "办公业务",icon:'../../static/logo/tabarIndexLogo/business.png'},
// 	{ icon:'other', title: "其他",value: "其他",icon:'../../static/logo/tabarIndexLogo/other.png'},
// 	{ icon:'LeadershipView', title: "领导视图",value: "领导视图",icon:'../../static/logo/tabarIndexLogo/LeadershipView.png'}
// // ]

export default [
	{
		name: '九阵服务',
		obj:'运维一部',
		type:'2580',
		describe:'2660',
		leader:'3894',
		state:'3315',
		ways:'1522',
		date: '2015-05-21 | 00：00：00',
		province: '四川',
		city: '宜宾市',
		address: '宜宾市临港经济区化工路70号邦泰临港国际12栋1单元104号',
		zip: 666666,
	  },
		{
			name: '远程服务',
			obj:'运维一部',
			type:'3660',
			describe:'2888',
			leader:'5512',
			state:'2356',
			ways:'13342',
			date: '2024-05-20 | 18：26：28',
			province: '云南',
			city: '水富市',
			address: '云南省水富市高滩坝水富市人民医院',
			zip: 200333,
		  },
		{
            name: '报表处理',
			obj:'运维二部',
			type:'4060',
			describe:'2896',
			leader:'3351',
			state:'4441',
			ways:'手动录入',
            date: '2023-05-20 | 18：26：28',
            province: '云南',
            city: '水富市',
            address: '云南省水富市高滩坝水富市人民医院',
            zip: 200333,
          },
		{
            name: '系统装机',
			obj:'运维二部',
			type:'1660',
			describe:'3065',
			leader:'2356',
			state:'8864',
			ways:'手动录入',
			date: '2024-09-22 | 02：28：28',
            province: '四川',
            city: '宜宾市',
            address: '云南省水富市高滩坝水富市人民医院',
            zip: 200333,
          },
		  {
			name: '院区截图',
			obj:'运维二部',
			type:'2060',
			describe:'3150',
			leader:'4457',
			state:'13425',
			ways:'4144',
			date: '2024-09-22 | 01：26：28',
			province: '云南',
			city: '水富市',
			address: '云南省水富市高滩坝水富市人民医院',
			zip: 200333,
			},
			{
			  name: '院区截图',
			  obj:'运维二部',
			  type:'1860',
			  describe:'5496',
			  leader:'3567',
			  state:'7423',
			  ways:'5673',
			  date: '2020-06-02 | 09：26：28',
			  province: '云南',
			  city: '水富市',
			  address: '云南省水富市高滩坝水富市人民医院',
			  zip: 200333,
			  },
			  {
				name: '院区截图',
				obj:'运维二部',
				type:'8886',
				describe:'6597',
				leader:'5523',
				state:'4521',
				ways:'12698',
				date: '2020-06-02 | 09：26：28',
				province: '上海',
				city: '普陀区',
				address: '云南省水富市高滩坝水富市人民医院',
				zip: 200333,
				},
			{
				name: '数据错误',
				obj:'运维二部',
				type:'8896',
				describe:'4125',
				leader:'6559',
				state:'11245',
				ways:'11245',
				date: '2019-05-02 | 08：26：28',
				province: '四川',
				city: '宜宾市',
				address: '四川省宜宾市川南骨科医院',
				zip: 200333,
			  },
]

